// Translations
import landing from '../views/landing/translations/ar'

// Translation: Verification (Arabic)
export default Object.freeze({
	name: 'تحقق',
	views: { landing }
})
